import axios from "axios";



axios.defaults.baseURL = process.env.MIX_API_URL;

export default function ApiService({ method, url, config = {} }) {
  return axios({
    method,
    url,
    data: {
      ...config.data
    },
    params: {
      ...config.params
    },
    headers: {
      locale: localStorage.getItem('lang') || 'en'
    },
    ramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: "comma" });
    }
  })

}


axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
    console.log(error);
  if (error.response.status === 401) {
    console.log('error :>> ', error.response.data.errors);
  }

  return Promise.reject(error);
});
